/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:18 GMT
 */
/* mixins & extensions */
/* helper to properly scale internal durations */
/**
* Currently only used in Checkbox.
*/
:host([disabled]) {
  cursor: default;
  -webkit-user-select: none;
          user-select: none;
  opacity: var(--calcite-opacity-disabled);
}

:host([disabled]) *,
:host([disabled]) ::slotted(*) {
  pointer-events: none;
}

:host([hidden]) {
  display: none;
}

[hidden] {
  display: none;
}

:host([disabled]) ::slotted([calcite-hydrated][disabled]),
:host([disabled]) [calcite-hydrated][disabled] {
  /* prevent opacity stacking */
  opacity: 1;
}

.interaction-container {
  display: contents;
}

:host {
  display: flex;
  --calcite-meter-space-internal: 0.125rem;
  --calcite-meter-height-internal: 1rem;
  --calcite-meter-font-size-internal: var(--calcite-font-size--1);
}

:host([scale=s]) {
  --calcite-meter-height-internal: 0.75rem;
  --calcite-meter-font-size-internal: var(--calcite-font-size--2);
}

:host([scale=l]) {
  --calcite-meter-height-internal: 1.5rem;
  --calcite-meter-font-size-internal: var(--calcite-font-size-0);
}

.container {
  position: relative;
  margin: 0px;
  display: flex;
  inline-size: 100%;
  align-items: center;
  block-size: var(--calcite-meter-height-internal);
  background-color: var(--calcite-color-foreground-2);
  border: 1px solid var(--calcite-color-border-3);
  border-radius: var(--calcite-meter-height-internal);
}

.solid {
  border: 1px solid var(--calcite-color-foreground-3);
  background-color: var(--calcite-color-foreground-3);
}

.outline {
  background-color: transparent;
}

.value-visible {
  margin-block-start: 1.5rem;
}

.steps-visible {
  margin-block-end: 1.5rem;
}

.step-line {
  position: absolute;
  inset-block: 0px;
  display: block;
  inline-size: var(--calcite-meter-space-internal);
  background-color: var(--calcite-color-border-3);
}

.label {
  position: absolute;
  font-size: var(--calcite-meter-font-size-internal);
}

.label-hidden {
  visibility: hidden;
  opacity: 0;
}

.label-value {
  inset-block-end: calc(100% + 0.5em);
  font-weight: var(--calcite-font-weight-bold);
  color: var(--calcite-color-text-1);
}

.label-range {
  color: var(--calcite-color-text-3);
  inset-block-start: calc(100% + 0.5em);
}

.unit-label {
  font-weight: var(--calcite-font-weight-medium);
  color: var(--calcite-color-text-3);
}

.label-value .unit-label {
  font-weight: var(--calcite-font-weight-bold);
  color: var(--calcite-color-text-2);
}

.fill {
  position: absolute;
  z-index: var(--calcite-z-index);
  display: block;
  background-color: var(--calcite-color-brand);
  transition-duration: 150ms;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  inset-inline-start: var(--calcite-meter-space-internal);
  inset-block: var(--calcite-meter-space-internal);
  border-radius: var(--calcite-meter-height-internal);
  max-inline-size: calc(100% - var(--calcite-meter-space-internal) * 2);
  min-inline-size: calc(var(--calcite-meter-height-internal) - var(--calcite-meter-space-internal) * 2);
  transition-property: inline-size, background-color, box-shadow;
}

.fill-danger {
  background-color: var(--calcite-color-status-danger);
}

.fill-success {
  background-color: var(--calcite-color-status-success);
}

.fill-warning {
  background-color: var(--calcite-color-status-warning);
}

.solid .fill {
  inset-block: 0;
  inset-inline-start: 0;
  max-inline-size: 100%;
  min-inline-size: calc(var(--calcite-meter-height-internal));
  box-shadow: 0 0 0 1px var(--calcite-color-brand);
}

.solid .fill-danger {
  box-shadow: 0 0 0 1px var(--calcite-color-status-danger);
}

.solid .fill-success {
  box-shadow: 0 0 0 1px var(--calcite-color-status-success);
}

.solid .fill-warning {
  box-shadow: 0 0 0 1px var(--calcite-color-status-warning);
}